import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {UserGroup} from '../../interfaces/UserGroup';
import ModalFixed from '../common/ModalFixed';
import UserGroupItemUpsert from './UserGroupItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: UserGroup;
  prefetch?: boolean;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
}

const UserGroupItemUpsertButton = <T extends ComponentType = typeof Button>({
  component,
  componentProps,
  children,
  onSubmitted,
  ...props
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component {...componentProps} onClick={() => setIsOpened(true)}>
        {children}
      </Component>

      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <UserGroupItemUpsert
          {...props}
          onSubmitted={() => {
            onSubmitted?.();
            setIsOpened(false);
          }}
          onClose={() => setIsOpened(false)}
        />
      </ModalFixed>
    </>
  );
};

export default UserGroupItemUpsertButton;
